import { render } from "./MINISTER_NEW.vue?vue&type=template&id=1be59b40"
import script from "./MINISTER_NEW.vue?vue&type=script&lang=js"
export * from "./MINISTER_NEW.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__